module.exports = __webpack_public_path__ + "img/3-9.e2d17834.png";